import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';
export interface SubscriptionReportState {
}

export default {
  state:{
    autoRenewalList:[],
  },
  mutations:{
  },
  actions:{
    getSubscrReport(context: ActionContext<SubscriptionReportState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `reports/get-subscr-report?requsername=${payload.username}&repname=${payload.repName}&isforced=true&pageno=&noofrec=&productGroupId=${payload.tenant}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getUserDetails(context: ActionContext<SubscriptionReportState, RootStoreState>, userId : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `users/get-user-details?username=${userId}`;
      return ApiServiceWrapper.get(endpoint);
    },
  },
  getters:{
  },
  namespaced: true,
} as Module<SubscriptionReportState, RootStoreState>;
